import React , {createContext  , useState} from "react" ;

const UserContext = createContext(null);

export const  UserContextProvider = ({children}) => {

const [userInfo, setUserInfo] = useState(null);

    const value = {
        userInfo, setUserInfo
    }

    return (
        <UserContext.Provider value={value} >
            {children}
        </UserContext.Provider>
    );
 

}

export default UserContext;